import { createReducer, on } from '@ngrx/store';
import { IEventQueryCommandState } from './states';
import * as EventQueryActions from './actions';
import { CalendarQueryCommand } from 'src/app/modules/shared/models/calendar.action.command';
import { setLocationGroups } from './actions';

export const initialState: IEventQueryCommandState = {
  command: new CalendarQueryCommand(),
  error: null,
};

export const eventQueryCommandReducers = createReducer(
  initialState,
  on(EventQueryActions.setDateRange, (state, action) => ({
    ...state,
    command: {...state.command, from: action.from, to: action.to, dateRange: action.dateRange},
  })),
  on(EventQueryActions.setLocation, (state, action) => ({
    ...state,
    command: {...state.command, location: action.location},
  })),
  on(EventQueryActions.setLocationGroups, (state, action) => ({
    ...state,
    command: {...state.command, locations: action.locations},
  })),
  on(EventQueryActions.setFavoriteEventBtnId, (state, action) => ({
    ...state,
    command: {
      ...state.command,
      favoriteEventBtnId: action.favBtnId,
      choice: undefined,
      updateURL: action.updateURL
    },
  })),
  on(EventQueryActions.setSearchText, (state, action) => ({
    ...state,
    command: {
      ...state.command,
      search: action.search,
      // favoriteEventBtnId: undefined,
      // choice: undefined,
      // from: undefined,
      // to: undefined,
    },
  })),
  on(EventQueryActions.setIsChoice, (state, action) => ({
    ...state,
    command: {
      ...state.command,
      choice: action.choice,
      favoriteEventBtnId: undefined,
    },
  }))
);
